import {
    faAlignJustify,
    faBed,
    faCircle,
    faHouseDamage,
    faUndo,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useUserInfor } from "../../../../Context/User";

interface IKPIAssistenciaTecnicaProps {
    DS_CATEGORIA_ATENDIMENTO_COMP: string;
    DT_SLA: string;
    FL_GARANTIA: boolean;
    DS_TIPO_RECORRENCIA?: string;
    COMODOS: [
        {
            ID_COMODO_ASSISTENCIA_TEC: number;
            DS_COMODO: string;
            ID_CASO: number;
        }
    ];
    FL_CASO_PARALIZADO: boolean;
}

export default function KPIAssistenciaTecnica(
    props: IKPIAssistenciaTecnicaProps
) {
    const { ID_ORGANIZACAO } = useUserInfor().OrgInfor;
    const dateSLA = new Date(props.DT_SLA);
    const dateHoje = new Date();
    const colorSLA =
        dateSLA.getDate() === dateHoje.getDate() &&
        dateSLA.getMonth() === dateHoje.getMonth() &&
        dateSLA.getFullYear() === dateHoje.getFullYear()
            ? "warning"
            : dateHoje < dateSLA || !props.FL_CASO_PARALIZADO
            ? "success"
            : "danger";

    const emccampMode =
        ID_ORGANIZACAO === "E830AEF3-49DF-4DC1-8560-DC78EE448F01";

    const colorGarantia = props.FL_GARANTIA ? "success" : "danger";
    return (
        <div className="d-flex align-items-center flex-wrap w-100">
            <div className="d-flex align-items-center flex-lg-fill mr-2 my-1">
                <span className="mr-4">
                    <FontAwesomeIcon
                        icon={faAlignJustify}
                        className="icon-2x text-muted font-weight-bold"
                    />
                </span>
                <div className="d-flex flex-column text-dark-75">
                    <span className="font-size-sm">
                        Categoria de Atendimento
                    </span>
                    <span className="font-weight-bolder">
                        <span className="text-dark-50 font-weight-bold">
                            {props.DS_CATEGORIA_ATENDIMENTO_COMP}
                        </span>
                    </span>
                </div>
            </div>
            {emccampMode && (
                <div className="d-flex align-items-center flex-lg-fill mr-2 my-1">
                    <span className="mr-4">
                        <FontAwesomeIcon
                            icon={faBed}
                            className="icon-2x text-muted font-weight-bold"
                        />
                    </span>
                    <div className="d-flex flex-column text-dark-75">
                        <span className="font-size-sm">Comodos</span>
                        <span className="font-weight-bolder">
                            <span className="text-dark-50 font-weight-bold">
                                <div className="d-flex flex-column">
                                    {props.COMODOS.map((comodo) => (
                                        <label>{comodo.DS_COMODO}</label>
                                    ))}
                                </div>
                            </span>
                        </span>
                    </div>
                </div>
            )}

            {props.DT_SLA && (
                <div className="d-flex align-items-center flex-lg-fill mr-2 my-1">
                    <span className="mr-4">
                        <FontAwesomeIcon
                            icon={faCircle}
                            className={`icon-2x text-${colorSLA} font-weight-bold`}
                        />
                    </span>
                    <div className="d-flex flex-column text-dark-75">
                        <span className="font-size-sm">SLA</span>
                        <span className="font-weight-bolder">
                            {new Date(props.DT_SLA).toLocaleString()}
                        </span>
                    </div>
                </div>
            )}
            <div className="d-flex align-items-center flex-lg-fill mr-2 my-1">
                <span className="mr-4">
                    <FontAwesomeIcon
                        icon={faHouseDamage}
                        className={`icon-2x text-${colorGarantia} font-weight-bold`}
                    />
                </span>
                <div className="d-flex flex-column text-dark-75">
                    <span className="font-size-sm">Garantia</span>
                    <span className="font-weight-bolder">
                        {props.FL_GARANTIA ? "No prazo" : "Fora do prazo"}
                    </span>
                </div>
            </div>
            {props.DS_TIPO_RECORRENCIA && (
                <div className="d-flex align-items-center flex-lg-fill mr-2 my-1">
                    <span className="mr-4">
                        <FontAwesomeIcon
                            icon={faUndo}
                            className={`icon-2x text-muted font-weight-bold`}
                        />
                    </span>
                    <div className="d-flex flex-column text-dark-75">
                        <span className="font-size-sm">
                            Atendimento Recorrente
                        </span>
                        <span className="font-weight-bolder">
                            {props.DS_TIPO_RECORRENCIA}
                        </span>
                    </div>
                </div>
            )}
        </div>
    );
}
